/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Faq_1_QInputs */

const en_b2b_faq_1_q = /** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does Bring-Your-Own-Domain (BYOD) mean?`)
};

const es_b2b_faq_1_q = /** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa Trae Tu Propio Dominio (BYOD)?`)
};

const fr_b2b_faq_1_q = /** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie Apporter-Son-Propre-Domaine (BYOD) ?`)
};

const de_b2b_faq_1_q = /** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet Bring-Your-Own-Domain (BYOD)?`)
};

const id_b2b_faq_1_q = /** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa maksudnya Bawa-Domain-Sendiri (BYOD)?`)
};

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const ja_b2b_faq_1_q = en_b2b_faq_1_q;

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const zh_b2b_faq_1_q = en_b2b_faq_1_q;

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const ar_b2b_faq_1_q = en_b2b_faq_1_q;

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const it_b2b_faq_1_q = en_b2b_faq_1_q;

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const ru_b2b_faq_1_q = en_b2b_faq_1_q;

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const pt_b2b_faq_1_q = en_b2b_faq_1_q;

/** @type {(inputs: B2b_Faq_1_QInputs) => LocalizedString} */
const ko_b2b_faq_1_q = en_b2b_faq_1_q;

/**
* | output |
* | --- |
* | "What does Bring-Your-Own-Domain (BYOD) mean?" |
*
* @param {B2b_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_faq_1_q = /** @type {((inputs?: B2b_Faq_1_QInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Faq_1_QInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_faq_1_q(inputs)
	if (locale === "es") return es_b2b_faq_1_q(inputs)
	if (locale === "fr") return fr_b2b_faq_1_q(inputs)
	if (locale === "de") return de_b2b_faq_1_q(inputs)
	if (locale === "ja") return ja_b2b_faq_1_q(inputs)
	if (locale === "zh") return zh_b2b_faq_1_q(inputs)
	if (locale === "ar") return ar_b2b_faq_1_q(inputs)
	if (locale === "id") return id_b2b_faq_1_q(inputs)
	if (locale === "it") return it_b2b_faq_1_q(inputs)
	if (locale === "ru") return ru_b2b_faq_1_q(inputs)
	if (locale === "pt") return pt_b2b_faq_1_q(inputs)
	return ko_b2b_faq_1_q(inputs)
});